import React from "react";
import "./PrivacyPolicyCard.css";

const PrivacyPolicyCard = () => {
  return (
    <div class="support-center">
      <div className="box">
        <p>
          Our application is designed to provide information about Galle Fort
          and its historical and cultural sites. We value your privacy and are
          committed to being transparent about how our application works. This
          application has been developed to provide tourists and visitors with
          information about Galle Fort, including its history, culture, and
          points of interest.
        </p>
        <p>
          Our application is designed to be open and accessible to everyone. We
          do not collect, store, or share any personal information from users.
          You can use all features of the app without creating an account or
          providing any personal details.
        </p>
        <p>
          The app may request access to your device’s location services in order
          to provide easier navigation and help you explore Galle Fort more
          conveniently. This information is used only on your device and is not
          collected, stored, or transmitted by us.
        </p>
        <p>
          This app can be used by people of all ages. Since we do not collect
          personal data, it is safe for children and families.
        </p>
        <p>
          We may update this Privacy Policy occasionally to reflect improvements
          or changes in the app. Updates will always be posted here. If you have
          any questions about this Privacy Policy, please reach us at:
          bytesquadra@gmail.com
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicyCard;
